import { defineRecipe } from '@chakra-ui/react'

export const separator = defineRecipe({
  className: 'Separator',
  base: {
    borderBottomWidth: '2px',
    borderColor: 'rgba(0,0,0,0.1)',
  },
  variants: {
    size: {
      sm: { margin: '0.5rem 0' },
      md: { margin: '1rem 0' },
      lg: { margin: '1.5rem 0' },
      xl: { margin: '2rem 0' },
    },
  },
  defaultVariants: {
    size: 'md',
  },
})
